module.exports = __webpack_public_path__ + "static/media/video_play_icon_large.1790fdae.svg";